import { render, staticRenderFns } from "./RelationWidget.vue?vue&type=template&id=4915f54d&scoped=true&"
import script from "./RelationWidget.vue?vue&type=script&lang=js&"
export * from "./RelationWidget.vue?vue&type=script&lang=js&"
import style0 from "./RelationWidget.vue?vue&type=style&index=0&id=4915f54d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4915f54d",
  null
  
)

export default component.exports